export default __webpack_public_path__ + "static/media/group-folders.786e7df1.svg";